import { render, staticRenderFns } from "./ImportDaysOff.vue?vue&type=template&id=2e2f1c74&"
import script from "./ImportDaysOff.vue?vue&type=script&lang=js&"
export * from "./ImportDaysOff.vue?vue&type=script&lang=js&"
import style0 from "./ImportDaysOff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports